module.exports = {"320203001":"迎龙桥街道","320203002":"南禅寺街道","320203003":"清名桥街道","320203004":"金星街道","320203005":"金匮街道","320203006":"扬名街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320203.json
// module id = 937
// module chunks = 0